import React, { useState, useEffect } from 'react';
import "./contact-us.css";
// svgs
import Email from '../../assets/icons/footer/email.svg'
import Clock from '../../assets/icons/footer/clock.svg'
import Instagram from '../../assets/icons/footer/instagram.svg'
import Whatsapp from '../../assets/icons/footer/whatsapp.svg'
import Youtub from '../../assets/icons/footer/youtub.svg'
import { getContact, imgBaseUrl2, getBranch } from '../../utils/api'
import ContactUsComponent from '../contact-us-component/contact-us'
import { Col, Form } from 'react-bootstrap';
import SecondaryBanner from '../banner/secondary-banner';
import LogoWhite from '../../assets/images/logo-shadow.svg';
import Img from '../../assets/images/img.jfif';
import TextBg from '../../assets/images/text-bg.svg';
import PhoneIcon from '../../assets/icons/phone.svg';
import Loader from '../../components/loader/dotloader'
import { Dialog } from 'primereact/dialog';
import CloseCollapse from '../../assets/icons/close.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import Phone from '../../assets/icons/phone-white.svg'
import Check from '../../assets/icons/check.svg'

const ContactUs = () => {
  const [contactInfo, setContactInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [branch, setBranch] = useState([]);
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedBranch, setSelectedBranch] = useState(null);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('visible')) {
      setVisible(true);
    }
  }, [location.search]);

  const handleCloseDialog = () => {
    setVisible(false);

    const params = new URLSearchParams(location.search);
    params.delete('visible');

    navigate(
      {
        pathname: location.pathname,
        search: params.toString()
          ? `?${params.toString()}`
          : ''
      },
      { replace: true }
    );
  };

  const fetchBranch = async (newPage = 0) => {
    try {
      setLoading(true);
      const pay = {
        pageIndex: 0,
        pageSize: 2000,
      };
      const res = await getBranch(pay);
      if (res.data.isSuccess) {
        // مرتب‌سازی بر اساس code
        const sortedBranches = res.data.data.items.sort((a, b) => a.code - b.code);

        setBranch(sortedBranches);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching branch:', error);
    }
  };
  useEffect(() => {

    fetchBranch();
  }, []);
  // Fetch categories
  useEffect(() => {
    const fetchContact = async () => {
      try {
        setLoading(true)
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getContact(pay);
        if (res.data.isSuccess) {
          const items = res.data.data.items;
          setContactInfo(items.filter((product) => product.isActive == true));
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
        console.error('Error fetching Contact:', error);
      }
    };
    fetchContact();
  }, []);
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [visible]);
  // Helper function to find a contact by title
  const getContactValue = (title) => {
    const contact = contactInfo.find((item) => item.title === title);
    return contact ? contact.value : '';
  };
  const getContactImage = (title) => {
    console.log(contactInfo)
    const contact = contactInfo.find((item) => item.title === title);
    return contact ? contact.logoPath : '';
  };
  return (
    <div>
      {loading && <Loader isLoading={loading} />}

      {/* <div>
        <SecondaryBanner slug='contactUs1' />
      </div> */}
      <div className='box-shadow'>

      </div>
      <section>
        <div className='row media mx-auto gy-4' style={{ marginTop: '5em' }}>
          {
            getContactValue('telephon') != '' && <a href={`tel:${getContactValue('telephon')}`} className=' col-md-6 col-lg-4 col-6'>

              <div className='item'>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('telephon')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>شماره تماس</h5>
                <h6>{getContactValue('telephon')}</h6>
              </div>

            </a>
          }
           {
            getContactValue('branchNum') != '' &&
            <a target='_blank' className=' col-md-6 col-lg-4 col-6'>
              <div className='item' onClick={(e) => setVisible(true)}>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('branchNum')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>شماره داخلی شعب</h5>
                <h6></h6>
              </div>
            </a>
          }

          {
            getContactValue('email') != '' &&
            <a href={`mailto:${getContactValue('email')}`} className=' col-md-6 col-lg-4 col-6'>
              <div className='item'>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('email')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>ایمیل</h5>
                <h6>{getContactValue('email')}</h6>
              </div>
            </a>
          }
          {
            getContactValue('answer') != '' &&
            <div className=' col-md-6 col-lg-4 col-6'>
              <div className='item'>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('answer')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>زمان پاسخگویی</h5>
                <h6>{getContactValue('answer')}</h6>
              </div>
            </div>
          }
          {
            getContactValue('instagram') != '' &&
            <a target='_blank' href={`https://instagram.com/${getContactValue("instagram")}`} className=' col-md-6 col-lg-4 col-6'>
              <div className='item'>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('instagram')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>اینستاگرام</h5>
                <h6>{getContactValue('instagram')}</h6>
              </div>
            </a>
          }
          {
            getContactValue('whatsapp') != '' &&
            <a href={`https://wa.me/${getContactValue("whatsapp")}`} target='_blank' className=' col-md-6 col-lg-4 col-6'>
              <div className='item'>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('whatsapp')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>واتساپ</h5>
                <h6>{getContactValue('whatsapp')}</h6>
              </div>
            </a>
          }
          {
            getContactValue('youtube') != '' &&
            <a href={`https://youtube.com/@${getContactValue("youtube")}`} target='_blank' className=' col-md-6 col-lg-4 col-6'>
              <div className='item'>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('youtube')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>یوتیوب</h5>
                <h6>{getContactValue('youtube')}</h6>
              </div>
            </a>
          }
          {
            getContactValue('aparat') != '' &&
            <a href={`https://aparat.com/${getContactValue("aparat")}`} target='_blank' className=' col-md-6 col-lg-4 col-6'>
              <div className='item'>
                <div className='icon-box'>
                  <img src={imgBaseUrl2 + 'io/' + getContactImage('aparat')} alt="" />
                </div>
                <h5 className='text-[#3E3E3E] text-base'>آپارات</h5>
                <h6>{getContactValue('aparat')}</h6>
              </div>
            </a>
          }
         
        </div>
      </section>
      <section className='mt-5 container'>
        <div className='more-info contact-us mx-0 bg-[#d1e6d2] flex-mob-col  rounded-[42px] d-flex align-items-center justify-content-center gap-5' style={{ position: 'relative' }}>
          <img src={TextBg} style={{ position: 'absolute', top: '0', left: '0' }} alt="" />
          <div className='w-3/5	max-sm:!w-full'>
            <h1 className='text-3xl font-bold leading-10 w-fit' style={{ borderBottom: '2px solid #00A14B' }}>امور مشتریان</h1>
            <div>
              <ContactUsComponent />

            </div>

          </div>
          {/* <div className='d-flex align-items-center gap-3 ml-4'>
            <div className='relative'>
              <img src={LogoWhite} alt="" style={{ position: 'absolute', top: '-3em', left: '-3em' }} />
              <div className='img-box'>
                <img className='rounded-3xl' src={Img} alt="" />

              </div>
              <div className='medal-box rounded-3xl'>
                <div className='medal-img-bottom'></div>
                <div className='medal-img-top'></div>
                <div className='medal-img'>
                  <img className='rounded-3xl' src={PhoneIcon} alt="" />

                </div>
              </div>
            </div>

          </div> */}
        </div>
      </section>


      <Dialog
        visible={visible}
        style={{ width: '50vw' }}
        breakpoints={{
          '1800px': '60vw',
          '1100px': '80vw',
          '600px': '95vw'
        }}
        contentStyle={{ minHeight: '70vh' }}
        onHide={handleCloseDialog}
        className="custom-dialog"
      >
        <div className="px-3 ">
          <h4 className="text-center mb-4 font-bold">
            شماره داخلی شعب               <a href={`tel:${getContactValue('telephon')}`}><span className='text-[#00a14b] text-sm'>({getContactValue('telephon')})</span></a> 

          </h4>
          <h6 className='!text-[#333333] '> در صورت تماس با شعب، شعبه مورد نظر را انتخاب کنید. </h6>

          <div className="branch-list row">
            {branch.map((item, index) => (

              <div className='col-12 col-md-4 ' key={item.id || index} onClick={() => setSelectedBranch(item)}>

                <div

                  className={`d-flex align-items-center justify-content-between border-bottom py-2 cursor-pointer ${selectedBranch?.id === item.id ? 'bg-[#00a14b17]' : ''
                    }`}

                > <div className='d-flex align-items-center'>
                    {selectedBranch?.id === item.id && <><img src={Check} alt="" /></>}
                    <span>{item.title || 'عنوان شعبه'}</span>
                  </div>

                  <span className="text-[#00a14b] font-bold">{item.code}</span>
                </div>
              </div>
            ))}

            <div className='d-flex align-items-center justify-content-end mt-4 phone-btn ' >

              <a className='d-flex align-items-center justify-content-center' href={
                selectedBranch
                  ? `tel:${getContactValue('telephon')};${selectedBranch.code}`
                  : '#'
              }>
                <button
                  className='btn btn-primary '
                  disabled={!selectedBranch}

                >

                  <img src={Phone} alt="" /> <span className='web-btn-text'>تماس با شعب</span>
                </button></a>

            </div>
          </div>






          <div className='dailog-max-btn-right'></div>
          <div className='dailog-max-btn-left'></div>
          <div className='bg-modal'>
            <div className="dailog-max-btn">

              <button className="btn" onClick={handleCloseDialog}>
                <img src={CloseCollapse} alt="Collapse" />
              </button>
            </div>
          </div>

        </div>
      </Dialog>
    </div>
  );
}

export default ContactUs;
